import { registerPlugin } from "@capacitor/core";

export interface AppleSignInResult {
  id_token: string;
  user_id: string;
  email?: string;
  given_name?: string;
  family_name?: string;
}

export interface GoogleSignInResult {
  id_token: string;
  email: string;
  given_name?: string;
  family_name?: string;
  picture?: string;
}

export interface StashtKeychainPlugin {
  saveTokens(options: { accessToken: string; refreshToken?: string }): Promise<void>;
  getTokens(): Promise<{ accessToken: string | null; refreshToken: string | null }>;
  clearTokens(): Promise<void>;
  saveWebCredential(options: { account: string; password: string; domain?: string }): Promise<void>;
  requestWebCredential(): Promise<{ email: string; password: string }>;
  signInWithApple(options?: { clientId?: string }): Promise<AppleSignInResult>;
  signInWithGoogle(options: { clientId: string }): Promise<GoogleSignInResult>;
}

const StashtKeychain = registerPlugin<StashtKeychainPlugin>("StashtKeychain", {
  web: {
    async saveTokens() {
      return;
    },
    async getTokens() {
      return { accessToken: null, refreshToken: null };
    },
    async clearTokens() {
      return;
    },
    async saveWebCredential() {
      return;
    },
    async requestWebCredential() {
      return { email: "", password: "" };
    },
    async signInWithApple() {
      throw new Error("Apple Sign-In is only available on iOS");
    },
    async signInWithGoogle() {
      throw new Error("Native Google Sign-In is only available on iOS/Android");
    },
  },
});

export { StashtKeychain };
